import { fromJS,List, Map, Record } from "immutable";

import createFromJS from "../../createFromJS";

export const IdReferenceList = Record({
  byId: Map(),
  allIds: List()
});

createFromJS.registerCallback("IdReferenceList", (typeName, any) => {
  const idObj = new IdReferenceList(fromJS(any)).update("byId", val => {
    const result = val.map(createFromJS[typeName]);
    return result;
  });
  return idObj;
});
